import script from "./LastImportWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./LastImportWidget.vue?vue&type=script&setup=true&lang=js"

import "./LastImportWidget.vue?vue&type=style&index=0&id=2f74e8fd&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f74e8fd"]])

export default __exports__